import * as React from 'react';
import { Messages } from '../../../../codegen/Localize';
import { L10n } from '../../../../ts/L10n/L10n';
import { DetailsTooltipStyles } from '../../CardView/DetailsTooltipStyles';

export interface UpdatedAt {
  value: Date;
}

export function UpdatedAt(props: UpdatedAt) {
  return (
    <div className={DetailsTooltipStyles.MetadataSection}>
      <span className={DetailsTooltipStyles.MetadataTitle}>{ Messages.modified() }</span>
      <span className={DetailsTooltipStyles.MetadataValue}>{ L10n.localizedDateTime(props.value) }</span>
    </div>
  );
}

